import { render, staticRenderFns } from "./ConfirmationInscription.vue?vue&type=template&id=21dccbd2&scoped=true"
import script from "./ConfirmationInscription.vue?vue&type=script&lang=js"
export * from "./ConfirmationInscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dccbd2",
  null
  
)

export default component.exports